import { render, staticRenderFns } from "./ModalDetalheAlerta.vue?vue&type=template&id=9bb0a148&scoped=true"
import script from "./ModalDetalheAlerta.vue?vue&type=script&lang=js"
export * from "./ModalDetalheAlerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb0a148",
  null
  
)

export default component.exports